import { match } from "ts-pattern";
import {
  TextAreaControlDataTypeKey,
  TextAreaControlDataTypeValueV1
} from "../../../controls";
function useTextAreaValue(data, definition) {
  const value = match(data).with({ [TextAreaControlDataTypeKey]: TextAreaControlDataTypeValueV1 }, (val) => val.value).otherwise((val) => val) ?? definition.config.defaultValue;
  return value;
}
export {
  useTextAreaValue
};
//# sourceMappingURL=text-area.js.map